import type { BlogOverviewDto } from '@gr/core/platform/admin/dto';

// ADM-UC-2: «Все блоги» — поиск и сортировка списка, который пришёл целиком.

export enum PlatformBlogSort {
  Name = 'name',
  Changed = 'changed',
  Created = 'created',
  Posts = 'posts',
  Media = 'media',
}

export const PLATFORM_BLOG_SORTS = Object.values(PlatformBlogSort);

/** По названию блога или логину владельца, без учёта регистра. */
export function filterPlatformBlogs(blogs: readonly BlogOverviewDto[], query: string): BlogOverviewDto[] {
  const q = query.trim().toLocaleLowerCase();
  if (!q) return [...blogs];
  return blogs.filter((blog) => blog.name.toLocaleLowerCase().includes(q) || blog.owners.some((owner) => owner.toLocaleLowerCase().includes(q)));
}

const newest = (a: string, b: string): number => Date.parse(b) - Date.parse(a);

/**
 * Название — по алфавиту языка интерфейса (порядок латиницы и кириллицы зависит от языка);
 * остальное — сначала больше или новее, при равенстве — по названию.
 */
export function sortPlatformBlogs(blogs: readonly BlogOverviewDto[], sort: PlatformBlogSort, locale: string): BlogOverviewDto[] {
  const byName = (a: BlogOverviewDto, b: BlogOverviewDto): number => a.name.localeCompare(b.name, locale);
  const compare: Record<PlatformBlogSort, (a: BlogOverviewDto, b: BlogOverviewDto) => number> = {
    [PlatformBlogSort.Name]: byName,
    [PlatformBlogSort.Changed]: (a, b) => newest(a.lastChangedAt, b.lastChangedAt),
    [PlatformBlogSort.Created]: (a, b) => newest(a.createdAt, b.createdAt),
    [PlatformBlogSort.Posts]: (a, b) => b.posts - a.posts,
    [PlatformBlogSort.Media]: (a, b) => b.mediaBytes - a.mediaBytes,
  };
  return [...blogs].sort((a, b) => compare[sort](a, b) || byName(a, b));
}
